import { DebugJson, DebugKv, DebugSection } from '../DebugSection';
import { computeLatencyStats } from '../services/apiCallLogStore';

export interface PerformanceSectionProps { searchTerm?: string }

export function PerformanceSection({ searchTerm }: PerformanceSectionProps): JSX.Element {
  const stats = computeLatencyStats();
  const rows: Array<{ k: string; v: unknown }> = [
    { k: 'fetch.count', v: stats.count },
    { k: 'fetch.p50.ms', v: stats.p50 },
    { k: 'fetch.p99.ms', v: stats.p99 },
    { k: 'fetch.mean.ms', v: stats.mean },
  ];

  let nav: PerformanceNavigationTiming | undefined;
  let paints: PerformanceEntry[] = [];
  let memory: unknown;
  if (typeof performance !== 'undefined') {
    try {
      nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    } catch { /* ignore */ }
    try { paints = performance.getEntriesByType('paint'); } catch { /* ignore */ }
    if ('memory' in performance) {
      memory = (performance as Performance & { memory?: unknown }).memory;
    }
    rows.push({ k: 'performance.now', v: Math.round(performance.now()) });
  }

  if (nav) {
    rows.push({ k: 'navigation.type', v: nav.type });
    rows.push({ k: 'navigation.domContentLoaded.ms', v: Math.round(nav.domContentLoadedEventEnd - nav.startTime) });
    rows.push({ k: 'navigation.loadEvent.ms', v: Math.round(nav.loadEventEnd - nav.startTime) });
    rows.push({ k: 'navigation.transferSize', v: nav.transferSize });
  }
  if (paints.length > 0) {
    for (const p of paints) {
      rows.push({ k: `paint.${p.name}.ms`, v: Math.round(p.startTime) });
    }
  }

  return (
    <DebugSection id="performance" title="10. Performance markers" searchTerm={searchTerm}>
      <DebugKv rows={rows} searchTerm={searchTerm} />
      {memory ? (
        <details className="pcb-debug-details">
          <summary>memory (Chromium-only)</summary>
          <DebugJson value={memory} />
        </details>
      ) : null}
    </DebugSection>
  );
}
